<template>
    <div>
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <label class="vs-input--label required">{{ $t('workShiftByDay.title') }}</label>
                    <vs-input class="w-full" v-model="title" type="text" data-vv-validate-on="blur"
                        v-validate="'required'" name="title" />
                    <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label ">{{ $t('invoice.note') }}</label>
                    <vs-input class="w-full" v-model="note" type="text" data-vv-validate-on="blur"
                    />
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <label class="vs-input--label required">{{ $t('news.selectClass') }}</label>
                    <v-select class="" v-model="classIds" :clearable="false" :options="classOptions"
                        :reduce="(option) => option.value" @input="changeDataStudent" v-validate="'required'"
                        name="class">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('class') }}</span>
                </div>
                <div class="vx-col md:w-full w-full mt-4">
                    <label class="vs-input--label">{{ $t('timeKeeping.student') }}</label>
<!--                    <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area&#45;&#45;nofications-dropdown2 p-0 mb-10"-->
<!--                                         :settings="settings" :key="$vs.rtl">-->
                    <v-select class="" v-model="studentIds" :clearable="false" :options="studentOptions" :multiple="true"
                        :reduce="(option) => option.value"
                        >
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
<!--                        <multiselect data-vv-validate-on="input" v-model="studentIds" :options="studentOptions"-->
<!--                                     group-values="libs"-->
<!--                                     group-label="all"-->
<!--                                     :group-select="true"-->
<!--                                     :show-labels="false"-->
<!--                                     :multiple="true"-->
<!--                                     :close-on-select="false"-->
<!--                                     placeholder=""-->
<!--                                     label="label"-->
<!--                                     track-by="value"-->
<!--                                     name="member"-->
<!--                        >-->
<!--                            <template #noResult>-->
<!--                                <span>Không có dữ liệu phù hợp!</span>-->
<!--                            </template>-->
<!--                            <template #noOptions>-->
<!--                                <span>Không có dữ liệu!</span>-->
<!--                            </template>-->
<!--                        </multiselect>-->
<!--                    </VuePerfectScrollbar>-->
                </div>


                <div class="vx-col md:w-1/4 w-full mt-4">
                    <label class="vs-input--label required">{{ $t('menuOrganization.fromDate') }}</label>
                    <div class="w-full">
                        <datepicker class="w-full" :language="vi" :format="'dd/MM/yyyy'" :highlighted="highlighted"
                            v-model="selectstartDate" data-vv-validate-on="input" ref="datepickBooking"
                            v-validate="'required'" name="timeStart">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('timeStart') }}</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-4">
                    <label class="vs-input--label required">{{ $t('multipleChoice.startTime') }}</label>
                    <div class="w-full">
                        <flat-pickr :config="configTimePicker" v-model="selectStartTime"
                            class="w-full vs-inputx vs-input--input normal" v-validate="'required'" name="hourStart" />
                    </div>
                    <span class="text-danger text-sm">{{ errors.first('hourStart') }}</span>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-4">
                    <label class="vs-input--label required">{{ $t('menuOrganization.endDate') }}</label>
                    <div class="w-full">
                        <datepicker class="w-full" :language="vi" :format="'dd/MM/yyyy'" :highlighted="highlighted"
                            v-model="selectendDate" data-vv-validate-on="input" ref="datepickBooking"
                            v-validate="'required'" name="timeEnd">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('timeEnd') }}</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-4">
                    <label class="vs-input--label required">{{ $t('multipleChoice.endTime') }}</label>
                    <div class="w-full">
                        <flat-pickr :config="configTimePicker" v-model="selectendTime"
                            class="w-full vs-inputx vs-input--input normal" v-validate="'required'" name="hourEnd" />
                    </div>
                    <span class="text-danger text-sm">{{ errors.first('hourEnd') }}</span>
                </div>


                <div class="vx-row">
                    <div class="vx-col w-full mb-5">
                        <div class="mt-8 ml-6 flex flex-wrap items-center justify-end">
                            <vs-button class="ml-auto mt-2" @click="sendQuiz"> {{ this.quizIdHistory  ? $t('multipleChoice.updated') : $t('multipleChoice.sendQuiz')  }}
                            </vs-button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker'
import { vi } from 'vuejs-datepicker/dist/locale'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Multiselect from 'vue-multiselect';
export default {
    components: {
        vSelect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar,
        Multiselect
    },
    props: {
        quizId: {
            type: Number,
            default: null,
        },
        quizIdHistory: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            vi: vi,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            // studentOptions: [
            //     {
            //         all: 'Tất cả',
            //         libs: []
            //     }
            // ],

            selectedOrganizationBranch: null,
            selectstartDate: null,
            selectStartTime: null,
            selectendDate: null,
            selectendTime: null,
            note: null,
            title: null,
            studentIds: [],
            classIds: [],
            classOptions: [],
            studentOptions: [],
            organizationBranchOptions: [],
            employeeId: 0,
            idquiz:null,
            dataUpdate:[],
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    async created() {
        let idInfor = JSON.parse(localStorage.getItem('userInfo') || '[]')
        this.employeeId = idInfor.employeeId
        let id = this.quizIdHistory
        await this.getClassPermission();
        if (id) {
            await this.getHistoryExam()
        }

    },
    methods: {
        changeDataStudent() {
            this.loadStudent()
        },
        getClassPermission() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.post(`/employee/find-by-id/${this.employeeId}`).then(res => {
                    if (res.data.managedClassRooms.length > 0) {
                        let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                        this.classOptions = res.data.managedClassRooms.map(el => {
                            let branch = branchList.find(x => x.id === el.organizationBranchId)
                            if (branch) el.organizationBranchName = branch.organizationBranchName
                            return {
                                value: el.id,
                                label: el.className + ' - ' + el.organizationBranchName,
                            }
                        })
                    } else {
                        this.classOptions = []
                    }
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },
        async getHistoryExam() {
            let id = this.quizIdHistory
            this.$crm.post(`/school-quiz/find-to-quiz/${id}`).then((res) => {
                this.dataUpdate = res.data
                this.title = res.data.title
                this.note = res.data.note
                const date = new Date(res.data.startDate);
                const formattedDate = date.toISOString().split('T')[0];
                this.selectstartDate = formattedDate
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                this.selectStartTime = formattedTime
                const enddate = new Date(res.data.endDate);
                const formattedEndDate = enddate.toISOString().split('T')[0];
                this.selectendDate = formattedEndDate
                const hoursEnd = enddate.getHours();
                const minutesEnd = enddate.getMinutes();
                const formattedEndTime = `${String(hoursEnd).padStart(2, '0')}:${String(minutesEnd).padStart(2, '0')}`;
                this.selectendTime = formattedEndTime;
                this.idquiz = res.data.quizId
                res.data.studentResponses.map(el => {
                    this.loadStudent(el.classId)
                    if (this.classOptions){
                        this.classOptions.map(t =>{
                            if(this.value = el.classId){
                                this.classIds = t.label
                            }
                            
                        })
                    }
                    this.studentIds.push(el.studentId)
                })
                this.$vs.loading.close();

            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        async sendQuiz(evt) {
            evt.preventDefault()
            if (!this.validateForm) return
            const result = await this.$validator.validateAll()
            if (!result) return

            const hours = parseInt(this.selectStartTime.split(':')[0])
            const minutes = parseInt(this.selectStartTime.split(':')[1])
            this.selectstartDate = new Date(this.selectstartDate)
            this.selectstartDate.setHours(hours, minutes, 0, 0)
            const hoursEnd = parseInt(this.selectendTime.split(':')[0])
            const minutesEnd = parseInt(this.selectendTime.split(':')[1])
            this.selectendDate = new Date(this.selectendDate)
            this.selectendDate.setHours(hoursEnd, minutesEnd, 59, 999)
            if (new Date(this.selectstartDate).getTime() >= new Date(this.selectendDate).getTime()) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            this.$vs.loading();
            let body = {
                quizId:this.idquiz ? this.idquiz : this.quizId,
                startDate: this.selectstartDate.toISOString(),
                endDate: this.selectendDate.toISOString(),
                note: this.note,
                title: this.title,
                classIds: this.studentIds.length > 0 ? null : [this.classIds],
                studentIds:this.quizIdHistory ? this.studentIds : this.studentIds

            }
            let url = this.quizIdHistory ? `/school-quiz/update-to-quiz/${this.quizIdHistory}` : `/school-quiz/send-to-quiz`
            this.$crm.post(url, body).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.quizIdHistory ? 'Cập nhật bài thi thành công!' : 'Giao bài tập thành công!' } `,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success',
                });
                if (this.quizIdHistory){
                    this.$store.commit('UPDATE_QUESTION', true);
                } else {
                    this.$store.commit('CLOSE_POPUP_EMPLOYEE', true);
                }

            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        loadStudent(id) {
            let idClass = id
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                let schoolStudentSearchDTO = {
                    organizationId: userInfo.organization.id,
                    sort: 'id',
                    classId: idClass ? idClass : this.classIds ,
                    enabled: true,
                    pageNumber: 1,
                    pageSize: 1000,
                }
                this.$crm.post('/school-student/find-by-condition', schoolStudentSearchDTO).then((response) => {
                    this.studentOptions = response.data.content.map(item => {
                        return {
                            value: item.id,
                            label: item.fullName,
                        }
                    });
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
    mounted() {
        this.$eventBus.$on('', () => {
            if(this.quizIdHistory){
                this.$store.commit('UPDATE_QUESTION', true);
            }else {
                this.$store.commit('CLOSE_POPUP_EMPLOYEE', true)
            }
        })
    },

}
</script>
<style>



</style>
